/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
export type Approvable = "NO" | "OPTIONAL" | "REQUIRED" | "%future added value";
export type DocumentStatus = "ACTIVE" | "DELETED" | "OLD" | "OLD_SAVE" | "PENDING" | "RETIRED" | "SAVED" | "SCHEDULED" | "%future added value";
import type { FragmentReference } from "relay-runtime";
declare export opaque type SecondaryNav_document$ref: FragmentReference;
export type SecondaryNav_document = {|
  +id: string,
  +pk: ?number,
  +name: string,
  +status: ?DocumentStatus,
  +approvable: Approvable,
  +rejectable: ?boolean,
  +shouldBeAcknowledged: ?boolean,
  +bloc: {|
    +tenants: ?$ReadOnlyArray<?{|
      +pk: ?number
    |}>
  |},
  +$refType: SecondaryNav_document$ref,
|};
*/


const node/*: ConcreteFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "pk",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "SecondaryNav_document",
  "type": "DocumentType",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "id",
      "args": null,
      "storageKey": null
    },
    v0,
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "name",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "status",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "approvable",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "rejectable",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "shouldBeAcknowledged",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "bloc",
      "storageKey": null,
      "args": null,
      "concreteType": "BlocType",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "tenants",
          "storageKey": "tenants(sort:\"name\")",
          "args": [
            {
              "kind": "Literal",
              "name": "sort",
              "value": "name",
              "type": "String"
            }
          ],
          "concreteType": "TenantType",
          "plural": true,
          "selections": [
            v0
          ]
        }
      ]
    }
  ]
};
})();

(node/*: any*/).hash = '0e35939b11c7a0350b15348c6e632ff0';
module.exports = node;
